const entertainmentArticles = [
  {
    id: 1,
    title: 'Lainey Wilson 纪录片定档 4 月 22 日上线 Netflix',
    date: '2026/04/22',
    updatedAt: '2026-04-21',
    summary:
      "截至 2026 年 4 月 21 日，Netflix 已将《Lainey Wilson: Keepin' Country Cool》排进 4 月 22 日片单，这部纪录片正处在上线前的热度窗口。",
    paragraphs: [
      '这条热点的核心，不只是新片定档，而是 Lainey Wilson 正处于从乡村歌手向全球流媒体受众扩圈的关键阶段。Netflix Tudum 与官方片页都把重点放在她从路易斯安那成长到格莱美获奖、再到巡演走红的完整路径上，内容定位很明确，就是一部“人物上升期”的音乐纪录片。',
      '从资源价值看，这一条非常适合首页娱乐焦点：上线日期明确、平台明确、人物知名度高，而且官方预告已经放出，用户点进去就能直接追更。页面里保留官方片页和 Tudum 新片导览，便于继续查看预告、简介和实际开播状态。',
    ],
    highlights: [
      'Netflix 官方片页已可查看预告与节目简介。',
      'Tudum 将其列为 2026 年 4 月 22 日重点上线内容。',
      '题材兼具音乐、人物成长与流媒体热度，适合作为当前热点。',
    ],
    resources: [
      {
        label: 'Netflix 官方片页',
        url: 'https://www.netflix.com/title/82152341',
      },
      {
        label: 'Netflix Tudum 4 月新片单',
        url: 'https://www.netflix.com/tudum/articles/new-on-netflix',
      },
      {
        label: 'Netflix Tudum 新预告汇总',
        url: 'https://www.netflix.com/tudum/articles/new-trailers-april-10-2026',
      },
    ],
  },
  {
    id: 2,
    title: '《Running Point》第二季 4 月 23 日回归',
    date: '2026/04/23',
    updatedAt: '2026-04-21',
    summary:
      'Netflix Tudum 已确认 Kate Hudson 主演的《Running Point》第二季将于 2026 年 4 月 23 日上线，属于本周最接近上线节点的热门剧集之一。',
    paragraphs: [
      '这部剧的优势在于轻喜剧、体育和明星阵容三条线同时成立。Tudum 的首发物料明确写到 LA Waves 会在 4 月 23 日重新开赛，说明平台已经把它放进本周主推位，热度天然高于普通库存剧。',
      '从更新策略看，它很适合放进“娱乐焦点”而不是深度影评区，因为用户最关心的是“什么时候回归”“谁回来了”“现在能去哪看”。所以这篇内容重点围绕档期、阵容和追剧入口整理，尽量让信息更实用。',
    ],
    highlights: [
      'Tudum 首图和文案已确认 4 月 23 日上线。',
      'Kate Hudson 继续出演，剧集维持体育喜剧定位。',
      '属于 4 月下旬平台主推回归内容，时效性强。',
    ],
    resources: [
      {
        label: 'Netflix Tudum 首发物料',
        url: 'https://www.netflix.com/tudum/articles/running-point-season-2-first-look-release-date',
      },
      {
        label: '《Running Point》预告与扩展内容',
        url: 'https://www.netflix.com/tudum/articles/running-point-season-2-first-look-release-date',
      },
    ],
  },
  {
    id: 3,
    title: '《Marty Supreme》4 月 24 日转入 HBO Max',
    date: '2026/04/24',
    updatedAt: '2026-04-21',
    summary:
      '美联社 2026 年 4 月 17 日的娱乐流媒体导览确认，《Marty Supreme》将于 4 月 24 日登陆 HBO Max，这让它重新回到本周热门片单中心。',
    paragraphs: [
      '这部片子的讨论度来自两个层面：一是 Timothee Chalamet 的明星效应，二是院线成绩和奖项表现带来的长尾关注。AP 在最新导览里直接把它列为“本周值得流媒体观看”的重点作品，说明它已经从院线热度顺势过渡到平台热度。',
      '对站内内容来说，这种“院线余温+流媒体首发”的电影最适合做焦点位。用户不一定关心完整影史位置，但会非常关心它是不是本周开始能看，以及它为什么又重新火起来。',
    ],
    highlights: [
      'AP 明确写到影片将于 2026 年 4 月 24 日上线 HBO Max。',
      '影片自带票房和奖项讨论，具备二次传播潜力。',
      '适合用作“本周该看什么”的电影热点入口。',
    ],
    resources: [
      {
        label: 'AP Entertainment 本周流媒体导览',
        url: 'https://apnews.com/article/b12444a52c1e57673fac9bdd6421c0b7',
      },
      {
        label: 'HBO 官方订阅入口',
        url: 'https://www.hbo.com/ways-to-get',
      },
    ],
  },
  {
    id: 4,
    title: 'Charlize Theron 新片《Apex》4 月 24 日上线',
    date: '2026/04/24',
    updatedAt: '2026-04-21',
    summary:
      'Netflix Tudum 在 2026 年 3 月 24 日和 3 月 25 日连续释出《Apex》物料，并明确影片将于 2026 年 4 月 24 日在 Netflix 开播。',
    paragraphs: [
      '《Apex》的话题点非常集中：Charlize Theron、Taron Egerton、澳洲荒野追逃、强类型动作惊悚。Tudum 用“cat and mouse”来定义这部片子的核心气质，既方便首页概括，也方便用户快速判断这是不是自己会点开的类型。',
      '这条资源比普通新闻更适合做详情页，是因为它已经具备预告、剧情简介和明确上线日，信息完整度足够高。和泛泛的娱乐热搜相比，这种能直接跳到官方内容页的资源更适合作为“最新资源”保留。',
    ],
    highlights: [
      'Tudum 已放出正式预告和剧情介绍。',
      'Netflix 官方确认 2026 年 4 月 24 日上线。',
      '动作惊悚题材清晰，适合当前娱乐热点栏目。',
    ],
    resources: [
      {
        label: 'Netflix Tudum《Apex》专题页',
        url: 'https://www.netflix.com/tudum/articles/apex-release-date-cast-news',
      },
      {
        label: 'AP Entertainment 本周导览',
        url: 'https://apnews.com/article/b12444a52c1e57673fac9bdd6421c0b7',
      },
    ],
  },
  {
    id: 5,
    title: 'Kehlani 同名新专辑锁定 4 月 24 日发售',
    date: '2026/04/24',
    updatedAt: '2026-04-21',
    summary:
      '美联社 4 月 17 日娱乐导览将 Kehlani 的同名新专辑列为 4 月 24 日重点新碟，官方商店也已同步显示该专辑将在同日发货。',
    paragraphs: [
      '这是一条典型的音乐热点资源。新闻层面，AP 直接把它放进本周新音乐推荐；商品层面，Kehlani 官方商店已经开启专辑与签名版周边预售，给了这条新闻很强的落地性。对于音乐向读者来说，这比单纯的热搜词条更有价值。',
      '把它放进首页焦点区的原因也很直接：人物知名度高、上线日期清晰、官方购买入口明确。用户看完可以继续去听、去收藏、去看周边，而不是停留在泛泛的一条娱乐快讯。',
    ],
    highlights: [
      'AP 将其列入 4 月 20 日到 26 日重点新音乐。',
      '官方商店显示专辑和签名版商品均在 4 月 24 日发货。',
      '兼具新闻热度和实际资源入口，转化更强。',
    ],
    resources: [
      {
        label: 'AP Entertainment 音乐推荐',
        url: 'https://apnews.com/article/b12444a52c1e57673fac9bdd6421c0b7',
      },
      {
        label: 'Kehlani 官方商店专辑页',
        url: 'https://store.kehlani.com/products/kehlani-signed-flower-cover-cd',
      },
      {
        label: 'Kehlani 官方商店套装页',
        url: 'https://store.kehlani.com/products/kehlani-album-tee-signed-cd',
      },
    ],
  },
  {
    id: 6,
    title: '戛纳电影节 2026 官方片单已于 4 月 9 日公布',
    date: '2026/04/09',
    updatedAt: '2026-04-21',
    summary:
      '第 79 届戛纳电影节官方资源显示，2026 年官方片单已于 4 月 9 日公布，电影节将于 5 月 12 日至 23 日举行。',
    paragraphs: [
      '电影节类热点的价值在于它会带动一整个月的电影讨论。官方媒体库已经把“Announcement of the 2026 Official Selection”放出，AP 也同步做了阵容报道，提到 Almodovar、Pawlikowski、Hamaguchi 等作者导演入围，让片单话题迅速扩散到全球影迷圈。',
      '从内容更新角度，这条信息必须保留，因为它不只是一个时间点新闻，而是之后所有“戛纳主竞赛”“电影节风向”“奖项前哨”内容的上游资源。把官方片单入口放进详情页，后续继续跟奖项结果也会更顺。',
    ],
    highlights: [
      '官方媒体库已公开 2026 年官方片单发布页。',
      '第 79 届戛纳电影节举办时间为 2026 年 5 月 12 日至 23 日。',
      'AP 指出本届主竞赛作者导演阵容很强，话题度持续走高。',
    ],
    resources: [
      {
        label: '戛纳官方片单发布页',
        url: 'https://www.festival-cannes.com/en/medialibrary/announcement-of-the-2026-official-selection/',
      },
      {
        label: 'AP 对 2026 戛纳阵容的报道',
        url: 'https://apnews.com/article/1ba159407b11ab4356f41dc44fd56a85',
      },
    ],
  },
  {
    id: 7,
    title: 'Coachella 2026 双周末演出成为 4 月音乐最大话题',
    date: '2026/04/19',
    updatedAt: '2026-04-21',
    summary:
      'Coachella 官网仍在展示 2026 年 4 月 10 日至 12 日、17 日至 19 日的双周末演出信息，AP 去年公布的阵容报道则点出了 Sabrina Carpenter、Justin Bieber 和 Karol G 等头牌。',
    paragraphs: [
      'Coachella 这种内容的意义不在于单条新闻，而在于它持续承接社交平台上的表演切片、穿搭热议、联名商品和音乐回流。官网依旧保留 2026 年阵容页和票务页，说明活动虽然接近收尾，但流量和搜索热度仍在。',
      '对于“娱乐焦点”来说，这是一条不能缺席的年度大型音乐节资源。既有官方时间和票务信息，也有 AP 对头牌阵容的总结，读者能同时获取活动入口和外部讨论坐标。',
    ],
    highlights: [
      '官网确认 2026 年演出日期为 4 月 10-12 日与 17-19 日。',
      'AP 阵容报道提到 Sabrina Carpenter、Justin Bieber、Karol G 等头牌。',
      '音乐、时尚、社交传播三条线同时带热，仍属当前热点。',
    ],
    resources: [
      {
        label: 'Coachella 官方阵容页',
        url: 'https://www.coachella.com/lineup',
      },
      {
        label: 'Coachella 官方票务页',
        url: 'https://coachella.com/passes',
      },
      {
        label: 'AP Coachella 2026 阵容报道',
        url: 'https://apnews.com/article/1462e271d788e52d277089b2645a87f1',
      },
    ],
  },
  {
    id: 8,
    title: '《Bloodhounds》第二季 4 月 3 日全球回归 Netflix',
    date: '2026/04/03',
    updatedAt: '2026-04-21',
    summary:
      'Netflix 官方在 2026 年 3 月 4 日确认《Bloodhounds》第二季将于 4 月 3 日全球上线，并同步发布新海报和预告。',
    paragraphs: [
      '韩剧板块的最新资源里，这一条很适合作为“硬类型热点”。Netflix 在官宣文里直接把卖点写成更大的地下拳赛、更狠的新反派和升级版动作场面，传播语言非常直给，也意味着平台对它的商业定位非常清晰。',
      '如果首页需要覆盖更广泛的娱乐兴趣，这种流媒体动作剧是很好的补位。它能覆盖喜欢韩国内容、动作题材和平台新剧的三类用户，不会让焦点区过度偏向电影节和欧美作品。',
    ],
    highlights: [
      'Netflix 官方已经给出正式上线日期和预告。',
      '第二季把故事升级到地下国际拳赛场景。',
      '动作类型鲜明，适合流量型娱乐栏目承接。',
    ],
    resources: [
      {
        label: 'Netflix 官方新闻稿',
        url: 'https://about.netflix.com/en/news/bloodhounds-season-2-premieres-april-3',
      },
      {
        label: 'Netflix 2026 剧集总表',
        url: 'https://www.netflix.com/tudum/articles/new-shows-on-netflix-2026',
      },
    ],
  },
  {
    id: 9,
    title: '第 98 届奥斯卡获奖名单出炉，奖季话题仍在延续',
    date: '2026/03/15',
    updatedAt: '2026-04-21',
    summary:
      '奥斯卡官网显示，第 98 届学院奖已于 2026 年 3 月 15 日举办，Michael B. Jordan、Jessie Buckley 与《KPop Demon Hunters》等获奖结果仍在持续影响 4 月的娱乐讨论。',
    paragraphs: [
      '奖季内容虽然不是“今天刚发生”，但它依旧是 4 月娱乐资源的重要索引。尤其是很多新片和流媒体上线都会继续借助奥斯卡成绩做传播，所以把官方获奖页收进热点列表，实际上是在给后续的电影与演员话题提供一条权威入口。',
      '这类内容的更新重点不在八卦，而在官方可核验。奥斯卡官网已经完整列出 2026 年的获奖与提名名单，因此详情页以“结果+影响”的方式处理，会比简单转载奖单更稳妥。',
    ],
    highlights: [
      '官网确认 98th Oscars 于 2026 年 3 月 15 日举行。',
      'Michael B. Jordan 获最佳男主角，Jessie Buckley 获最佳女主角。',
      '《KPop Demon Hunters》获得最佳动画长片，仍具讨论热度。',
    ],
    resources: [
      {
        label: '奥斯卡 2026 官方获奖页',
        url: 'https://www.oscars.org/oscars/ceremonies/2026',
      },
      {
        label: '奥斯卡数据库搜索页',
        url: 'https://awardsdatabase.oscars.org/search/',
      },
    ],
  },
  {
    id: 10,
    title: '朴赞郁出任 2026 戛纳主竞赛评审团主席',
    date: '2026/02/26',
    updatedAt: '2026-04-21',
    summary:
      '戛纳官方于 2026 年 2 月 26 日宣布，韩国导演朴赞郁将担任第 79 届戛纳电影节主竞赛评审团主席，这是韩国电影首次获得这一位置。',
    paragraphs: [
      '这条消息本身发布时间早于 4 月下旬，但随着 2026 片单已公布，它的热度其实正在二次升温。朴赞郁担任评审团主席，不仅是作者电影圈的大事件，也会直接影响本届电影节的话题中心与媒体关注方向。',
      '把它作为第十篇保留在栏目里，有一个很实际的原因：它和官方片单那篇可以形成联动。一个回答“谁来评”，一个回答“谁入围”，两条一起放，电影节线索会更完整。',
    ],
    highlights: [
      '朴赞郁为韩国电影首次担任戛纳主竞赛评审团主席。',
      '官方公告发布时间为 2026 年 2 月 26 日。',
      '与 4 月公布的官方片单形成直接联动，仍具阅读价值。',
    ],
    resources: [
      {
        label: '戛纳官方公告',
        url: 'https://www.festival-cannes.com/en/press/press-releases/park-chan-wook-president-of-the-jury-of-the-79th-festival-de-cannes/',
      },
      {
        label: '戛纳官方媒体页',
        url: 'https://www.festival-cannes.com/en/medialibrary/announcement-of-the-2026-official-selection/',
      },
    ],
  },
]

export default entertainmentArticles
